import { isXs } from './response-query';

function init(name, Component, asyncStyles) {
  customElements.define(
    name,
    class extends Component {
      static get styles() {
        return asyncStyles;
      }
    },
  );
}

/* example
  defineComponent("name", ClassElement, {
    mobile: () => import("./mobile.js"),
    desktop: () => import("./desktop.js")
  }, commonCss);
 */
export function defineComponent(name, Component, asyncStylesMap, syncStyles) {
  if (!customElements.get(name)) {
    (isXs() ? asyncStylesMap.mobile() : asyncStylesMap.desktop()).then(({ styles }) =>
      init(name, Component, [syncStyles, styles]),
    );
  }
}

export function safeDefine(name, Component) {
  if (!customElements.get(name)) {
    customElements.define(name, Component);
  }
}
